import { render, staticRenderFns } from "./upload-3.vue?vue&type=template&id=25373998"
import script from "./upload-3.vue?vue&type=script&lang=js"
export * from "./upload-3.vue?vue&type=script&lang=js"
import style0 from "./upload-3.vue?vue&type=style&index=0&id=25373998&lang=css"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25373998')) {
      api.createRecord('25373998', component.options)
    } else {
      api.reload('25373998', component.options)
    }
    module.hot.accept("./upload-3.vue?vue&type=template&id=25373998", function () {
      api.rerender('25373998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-image-crop-upload/upload-3.vue"
export default component.exports